import Vue from 'vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import TextInput from '../../component/dccore-form/textInput.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import DatePicker from '@component/dccore-form/datePicker.vue'
import { NTFY_CZ_ID, NTFY_DE_ID } from '@const/common'

if ($('#meal_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#meal_form',
    components: {
      TextInput,
      Multiselect,
      RingLoader,
      Singleselect,
      multimedia,
      NumberInput,
      Checkbox,
      DatePicker
    },
    mixins: [mixins],
    data: {
      form: {
        entity: {
          'level': 1,
          'kind': 'component_meal',
          'status': 'stage_concept',
          unit: 'piece',
          portions: [],
          mealGroup: {},
          mealCategories: [],
          isNew: false,
          needPhotoSession: false,
          descriptionForClient: null,
          selectedBrands: [],
          brands: [],
          superiorUnfoldingTeam: null,
          ntfyId: null,
        },
        options: {
          errors: {},
          tags: [],
          nests: [],
          teams: [],
          brands: [],
          types: [],
          labels: [],
          labelsSecond: [],
          labelsThird: [],
          mealGroups: [],
          mealCategories: [],
          workTags: [],
          portions: [],
          units: [],
          kinds: [],
          stages: [],
          equipments: [],
          componentMeals: [],
          subcomponentsMeals: [],
          unfoldingTeams: [],
          badges: [],
        },
        associatedUnfoldingTeam: null,
        mealBadge: {
          id: null,
          badge: null,
          validFrom: null,
          validTo: null,
        },
      },
      loading: 0,
      mealId: null,
      allergens: [],
      stringAllergens: null,
      changeAllergen: 0,
      selectedNests: [],
      selectedWorkTags: [],
      selectedPortions: [],
      selectedSubcomponentsMeals: [],
      selectedComponentMeals: [],
      multimedia: [],
      isNtfyIdForCopyDisabled: true,
      blockingFieldEditing: false,
      blockingLabelDescriptionEditing: false,
      blockingWorkTagEditing: false,
      blockingFieldsEditingBySourceD365: false,
      ntfyDeId: NTFY_DE_ID,
    },
    computed: {
      isDefaultTeamDisabled() {
        return this.form.entity.ntfyId &&
          this.form.entity.selectedBrands.some(value => [NTFY_DE_ID, NTFY_CZ_ID].includes(value))
      },
    },
    watch: {
      'form.entity.kind' : function (kind) {
        if (kind === 'final_meal') {
          this.form.entity.unit = 'piece'
        }
      },
      'form.entity.brands': {
        handler(value) {
          this.isNtfyIdForCopyDisabled = !value || !value.includes(NTFY_DE_ID)
        },
        deep: true,
        immediate: true,
      }
    },
    async mounted() {
      this.loading++

      if ($('#entity_id').length) {
        this.mealId = $('#entity_id').val()
        this.form.mealBadge.meal = this.mealId
        this.getMeal()
      }

      this.getItemsForCreateAllergens()
      this.getTags()
      this.getWorkTags()
      this.getBrands()
      this.getTypes()
      this.getLabels()
      this.getLabelsSecond()
      this.getLabelsThird()
      this.getKinds()
      this.getStages()
      this.getEquipments()
      this.getUnits()
      this.getMealCategories()
      this.getNests()
      this.getActiveTeams()
      this.getActiveUnfoldingTeams()
      await this.updateAssociatedUnfoldingTeam()
      await this.getMealGroups()
      await this.checkForDefaultMealGroup()

      this.loading--
    },
    methods: {
      async checkForDefaultMealGroup() {
        return new Promise((resolve, reject) => {
          const defMealGroup = this.form.options.mealGroups.find(mealGroup => mealGroup.value === 'Pozostałe')
          if (!this.form.entity.mealGroup && this.form.entity.kind === 'final_meal') {
            this.form.entity.mealGroup = defMealGroup
            this.form.entity.selectedMealGroup = defMealGroup.id
          }
          resolve()
          reject()
        })
      },
      createMeal(redirect) {
        if (this.form.entity.kind === 'component_meal' || !this.$refs.errorChecker.errorCheck()) {
          this.loading++
          let url = Routing.generate('api_post_meal')
          this.form.entity.portions = this.selectedPortions
          this.form.entity.workTags = [...this.selectedWorkTags, ...this.selectedNests]

          if (this.form.entity.kind === 'component_meal') {
            this.form.entity.subcomponentsMeals = this.selectedSubcomponentsMeals
          } else {
            this.form.entity.componentMeals = this.selectedComponentMeals
          }

          let data = {
            data: this.form.entity,
            multimedia: this.form.entity.kind === 'component_meal' ? [] : this.multimedia,
          }

          this.$http.post(url, data).then(() => {
            this.errors = {}
            if (redirect) {
              $(location).attr('href', Routing.generate('meal_grid'))
            } else {
              toastr.success(Translator.trans('form.created'))
            }
            this.loading--
          }, response => {
            this.loading--
            this.handleAjaxError(response, this.form.options)
          })
        }
      },
      updateMeal(redirect) {
        if (this.form.entity.kind === 'component_meal' || !this.$refs.errorChecker.errorCheck()) {
          let url = Routing.generate('api_patch_meal', { id: this.mealId })
          this.form.entity.portions = this.selectedPortions
          this.form.entity.workTags = [...this.selectedWorkTags, ...this.selectedNests]

          if (!this.form.mealBadge.badge && !this.form.mealBadge.validFrom && !this.form.mealBadge.validTo) {
            this.form.entity.mealBadges = []
          } else {
            this.form.entity.mealBadges = [this.form.mealBadge]
          }

          if (this.form.entity.kind === 'component_meal') {
            this.form.entity.subcomponentsMeals = this.selectedSubcomponentsMeals
          } else {
            this.form.entity.componentMeals = this.selectedComponentMeals
          }

          let data = {
            data: this.form.entity,
            multimedia: this.form.entity.kind === 'component_meal' ? [] : this.multimedia,
          }

          this.loading++
          this.$http.patch(url, data).then(() => {
            this.errors = {}
            if (redirect) {
              $(location).attr('href', Routing.generate('meal_grid'))
            } else {
              toastr.success(Translator.trans('form.updated'))
              this.form.options.errors = {}
            }
            this.loading--
          }, response => {
            this.loading--
            this.handleAjaxError(response, this.form.options)
          })
        }
      },
      getMeal() {
        let url = Routing.generate('api_get_meal', { id: this.mealId,
          context: 'edit' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.entity = response.data.meal
          this.selectedPortions = response.data.meal.selectedPortions
          this.selectedSubcomponentsMeals = response.data.meal.subcomponentsMeals
          this.selectedComponentMeals = response.data.meal.componentMeals
          this.blockingFieldEditing = response.data.blockingFieldEditing
          this.blockingLabelDescriptionEditing = response.data.blockingLabelDescriptionEditing
          this.blockingWorkTagEditing = response.data.blockingWorkTagEditing
          this.blockingFieldsEditingBySourceD365 = response.data.blockingFieldsEditingBySourceD365

          if (this.form.entity.multimedia) {
            this.multimedia = this.form.entity.multimedia.collection

            delete this.form.entity.multimedia
          }

          if (this.form.entity.mealBadges && this.form.entity.mealBadges.length) {
            this.form.mealBadge = this.form.entity.mealBadges[0]
          }

          this.getBadges()
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getTags() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'meal_tag',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.tags = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getNests() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'nest',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.nests = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getWorkTags() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'meal_work_tag',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.workTags = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getMealCategories() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'meal_category',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.mealCategories = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      async getMealGroups() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'meal_group',
          context: 'dropdown' })
        return this.$http.get(url).then(response => {
          this.form.options.mealGroups = response.data
          this.loading--
        }).catch(response => this.handleAjaxError(response))
      },
      getEquipments() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'equipment',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.equipments = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getTypes() {
        this.loading++
        let url = Routing.generate('api_get_meal_types', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.types = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getPortions() {
        let url = Routing.generate('api_get_materials_portions', { context: 'dropdown' })
        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      getSubcomponentsMeals() {
        let url = Routing.generate('api_get_meal_available_subcomponent_meals', { 'id': this.mealId })
        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      getComponentMeals() {
        let url = Routing.generate('api_get_meals_by_kind', { kind: 'component_meal',
          context: 'dropdown' })
        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      getLabels() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'meal_label',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.labels = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getLabelsSecond() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'meal_label_second',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.labelsSecond = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getLabelsThird() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'meal_label_third',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.labelsThird = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getKinds() {
        this.loading++
        let url = Routing.generate('api_get_meals_kinds')
        this.$http.get(url).then(response => {
          this.loading--
          this.form.options.kinds = response.data
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getStages() {
        let url = Routing.generate('api_get_meals_stages')
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.stages = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      /**
             * get all available units from server
             */
      getUnits() {
        let url = Routing.generate('api_get_materials_units')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.units = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getAllergens() {
        setTimeout(() => {
          let portions = this.selectedPortions
          let subcomponentsMeals = this.form.entity.kind === 'final_meal' ? this.selectedComponentMeals : this.selectedSubcomponentsMeals

          let url = Routing.generate('api_post_meal_allergens_names')
          this.$http.post(url, {
            portions: portions,
            subcomponentsMeals : subcomponentsMeals
          }).then(response => {
            this.allergens = response.data
            this.stringAllergens = this.allergens.join(', ')
          }, response => {
            this.handleAjaxError(response)
          })
        }, 0)
      },
      getActiveTeams() {
        let url = Routing.generate('api_get_active_production_teams', { context: 'dropdown_extra' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.teams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getActiveUnfoldingTeams() {
        let url = Routing.generate('api_get_active_unfolding_teams', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.unfoldingTeams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getBadges() {
        const url = Routing.generate('api_get_badges', {
          context: 'dropdown',
          isActive: true,
          brandIds: this.form.entity.selectedBrands,
        })

        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.badges = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      updateAssociatedUnfoldingTeam() {
        if (!this.form.entity.defaultTeam) {
          this.form.associatedUnfoldingTeam = null
          return
        }

        let selectedTeamId = this.form.entity.defaultTeam
        let selectedTeamOption = this.form.options.teams.find((option) => option.id === selectedTeamId)
        if (!selectedTeamOption.associatedUnfoldingTeam) {
          this.form.associatedUnfoldingTeam = null
          return
        }

        this.form.associatedUnfoldingTeam = selectedTeamOption.associatedUnfoldingTeam.name
      },
      translateKind(name) {
        return Translator.trans(`meal.entity.kinds.${name}`)
      },
      translateStage(name) {
        return Translator.trans(`meal.entity.stages.${name}`)
      },
      async getItemsForCreateAllergens() {
        this.loading++
        this.form.options.portions = await this.getPortions()
        this.form.options.componentMeals = await this.getComponentMeals()
        this.form.options.subcomponentsMeals = await this.getSubcomponentsMeals()
        this.$watch('selectedSubcomponentsMeals', function () {
          this.getAllergens()
        })
        this.$watch('componentMeals', function () {
          this.getAllergens()
        })
        this.$watch('subcomponentsMeals', function () {
          this.getAllergens()
        })
        this.getAllergens()
        this.loading --
      },
    }
  })
}
